var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":_vm.name}},[_c('input',{attrs:{"type":"checkbox","name":_vm.name},domProps:{"checked":_vm.checked},on:{"input":_vm.handleInput}}),_c('span',{staticClass:"checkbox-custom"}),_vm._v("\n  "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }